import React, {useState, useEffect, Fragment}  from 'react';
import {Alert, Table, Spinner, Button} from 'react-bootstrap';
import {useNavigate, useParams, useSearchParams, Link} from 'react-router-dom';
import axios from 'axios';
import {apiUrl, reportStartDateDiff, reportEndDateDiff, clusterApi} from '../../../../util/Api';
import PRContent from '../../components/PRContent';
import { toFactDate, fromFactDate, isFactDate, truncate } from '../../../../util/ChartUtils';


const ResponseClustersSection = (props) => {

    const [errors, setErrors] = useState([]);
    const [clusters, setClusters] = useState([]);
    const [datesForLink, setDatesForLink] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    let {accountKey, appKey, startFactDate, endFactDate } = useParams();

    const [searchParams] = useSearchParams();
    let role = searchParams.get('role');
    let filters = (role ? `role=${role}` : '');

    //to easily migrate back / forth from live clustering 
    const routeVersion = '' 
    //const routeVersion = 'live'

    let navigate = useNavigate();

    //console.log(`response: ${responseId}`)
    useEffect(() => {
        let linkDates = "";
        if(startFactDate != null && startFactDate != ""){
            linkDates = `/${startFactDate}`;
            if(endFactDate != null && endFactDate != "") {
                linkDates += `/${endFactDate}`;
            }
            setDatesForLink(linkDates);
        }

        let startDate = new Date();
        let endDate = new Date();
        let startFact = startFactDate;
        let endFact = endFactDate;

        if (!isFactDate(endFact)) {
            //console.log('endFactDate is null')
            endDate.setDate(endDate.getDate() - reportEndDateDiff);
            endFact = toFactDate(endDate);
        } else {
            //console.log('endFactDate is not null', endFact)
            endDate = fromFactDate(endFact);
        }

        if (!isFactDate(startFact)) {
            //console.log('startFactDate is null')
            startDate.setDate(endDate.getDate() - reportStartDateDiff);
            startFact = toFactDate(startDate);
        } else {
            //console.log('startFactDate is not null', startFact)
            startDate = fromFactDate(startFact);
        }

        let options = {
            accountKey: accountKey,
            appKey: appKey,
            startDate: startFact,
            endDate: endFact
        }
        if(role != null && role != ""){
            options.role = role;
            options.byRole = 1;
        }
        let isAuthError = false;
              
        axios.post(clusterApi + '/responseclusters',
            options, { withCredentials: true })
            .then((res) => {
                if (res.data.status === 'ok') {
                    //clear errors 
                    if(errors?.length > 0) {
                        setErrors([])
                    }
                    if (res.data.clusters !== null) {
                        //console.log(res.data.clusters)
                        setClusters(res.data.clusters);
                    }
                } else {
                    if(clusters?.length > 0) {
                        setClusters([])
                    }
                    if(isLoading){
                        setIsLoading(false)
                    }
                    let errorMsgs = [];
                    let redirectToLogin = false;
                    res.data.errors.forEach((error, i) => {
                        switch (error) {
                            case 'auth-expired':
                            case 'auth-error':
                            case 'no-auth':
                            case 'no-valid-account':
                            case 'no-permissions':
                                //console.log('auth expired');
                                isAuthError = true;
                                redirectToLogin = true;
                                break;
                            case 'no-app':
                            case 'no-valid-app':
                                //console.log('no results')
                                errorMsgs.push('There was no matching app.');
                                break;
                            case 'no-results':
                                //console.log('no results')
                                errorMsgs.push('There were no matching clusters for this time period.');
                                break;
                            default:
                                //TODO: may want to just ignore - no sense showing anything?
                                errorMsgs.push('There was an error retrieving clusters.');
                        }
                    });
                    //don't call setErrors if not logged in as it throws an unmounted error
                    if (redirectToLogin) {
                        navigate('/login');
                        return;
                    }
                    if (!isAuthError) {
                        setErrors(errorMsgs);
                    }
                }
            })
            .catch((err) => {

            });
            

    },[accountKey, appKey, startFactDate, endFactDate, role]);

    const rowClickHandler = (e) => {
        const elem = e.currentTarget.nextSibling;
        const arrow = e.currentTarget.firstChild;
        if(elem.className.indexOf('collapse show') > -1) {
          elem.classList.remove('show')
          arrow.innerHTML = "<img src='/icon-expand.png' width='20' height='20'/>";
        } else {
          elem.classList.add('show')
          arrow.innerHTML = "<img src='/icon-collapse.png' width='20' height='20'/>";
        }
      }

    const sortByPrimaryResponse = () => {
        //console.log('sorting response')
        let temp = [...clusters]
        temp.sort((a,b) => (a.primaryResponse < b.primaryResponse) ? -1 : 1)
        setClusters(temp);
    }

    const sortByInteractions = () => {
        //console.log('sorting response')
        let temp = [...clusters]
        temp.sort((a,b) => (a.interactions < b.interactions) ? 1 : -1)
        setClusters(temp);
    }
    const sortByResponseCount = () => {
        //console.log('sorting response')
        let temp = [...clusters]
        temp.sort((a,b) => (a.responseCount < b.responseCount) ? 1 : -1)
        setClusters(temp);
    }

    return (
        <>
        {/*<div className={responseId != null ? 'chart-card' : ''}> */}
        <div className='chart-card'>
            
            {
                errors.length > 0 ? (
                    <Alert variant='danger' className='mt-3'>
                        {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
                    </Alert>
                ) : (null)
            }
            {
                    clusters.length > 0 ? (
                        <>
                            <h4></h4>
                            <Table borderless size='sm'>
                                <thead>
                                    <tr>
                                        <th style={{width:'30px'}} ></th>
                                        <th ><span onClick={sortByPrimaryResponse} role="button">cluster</span></th>
                                        <th></th>
                                        <th className='text-end'><span onClick={sortByResponseCount} role="button">responses</span></th>
                                        <th className='text-end'><span onClick={sortByInteractions} role="button">interactions</span></th>
                                        

                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        clusters.map((cluster, i) => (
                                            <Fragment key={'cluster.' + i}>
                                           <tr onClick={rowClickHandler} data-toggle="collapse" data-target={`cluster-detail-${i}`} aria-controls={`cluster-detail-${i}`}>
                                                <td ><img src='/icon-expand.png' width='20' height='20'/></td>
                                                <td  ><div className='chat-bubble mb-3'><PRContent text={truncate(cluster.primaryResponse, 200)}/></div></td>
                                                <td><Link className='btn btn-sm btn-theme' to={`/account/${accountKey}/analytics/app/${appKey}/responsecluster${routeVersion}/${cluster.primaryId}${datesForLink}`}>explore</Link></td>
                                                <td className='text-end'>{cluster.responseCount}</td>
                                                <td className='text-end'>{cluster.interactionsTotal}</td>
                                                
                                            </tr>
                                            <tr className='collapse' id={`cluster-detail-${i}`}>
                                                <td></td>
                                                <td colSpan={4}  style={{'backgroundColor': '#e5f2ff','borderRadius':'10px'}}>
                                                    <Table borderless size='sm' >
                                                        {/*<thead>
                                                            <tr>
                                                            <th>Response</th>
                                                            <th className='text-end'>Similarity</th>
                                                            <th className='text-end'>Interactions</th>
                                                            </tr>
                                                        </thead>*/}
                                                        <tbody >
                                                            {
                                                            cluster.responses.map((response, p) => (
                                                                <tr key={`response-${i}-${p}`}>
                                                                    <td><Link to={`/account/${accountKey}/analytics/app/${appKey}/responseflow/${cluster.primaryId}${datesForLink}`}><div className='chat-bubble mb-3'><PRContent text={truncate(response.response, 200)}/></div></Link></td>
                                                                    {/*<td className='text-end'>{response.score}</td>*/}
                                                                    <td className='text-end'>{response.interactions}</td>
                                                                </tr>
                                                            ))
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </td>
                                            </tr>
                                            </Fragment>
                                        ))
                                    }
                                </tbody>
                            </Table>
                        </>
                    ) : (
                        <>
                        {
                            isLoading == true ? (
                                <Alert variant='primary'>
                                    <div className='d-inline-flex'>
                                    <div><Spinner animation="border" variant='secondary'/></div>
                                    <div className='ms-3'>Analyzing similar responses... </div>
                                    </div>
                                    
                                </Alert>
                            ) 
                            : (null)
                        }
                    </>
                    )
                }
        </div>
        </>
    )
}

export default ResponseClustersSection